type GetAutoshipData = {
    unit: string;
    frequency: string;
};

export const getAutoshipData = ({ frequency, unit }: GetAutoshipData) => {
    return {
        autoshipFrequency: frequency,
        autoshipFrequencyUnitOfMeasure: unit,
    };
};
